import { backgroundColor, fontColor, padding, border, boxShadow, gradientImage } from "../styleProperties";

export default {
  methods: {

    getCardProperties(data) {
      return {
        backgroundColor: this.getBackgroundColor(data),
        elevation: this.getBoxShadow(data),
        shaped: 'shaped' == this.getBoxShape(data),
        tile: 'tile' === this.getBoxShape(data),
        style: this.getStyleObject(data)
      }
    },

    getStyleObject(item) {
      const style = (item.inherit || false) ?  this.css : item;

      const styles = {
        ...backgroundColor(style),
        ...fontColor(style),
        ...border((style.inherit || false) ? this.css.border : style.border)
      };

      /*
      if (this.$vuetify.breakpoint.smAndDown) {
          return styles
      }
      */

      return {
        ...styles,
        ...padding(style)
      }

    },
    getBackgroundColor(item) {
      return backgroundColor(item)
    },
    getGradientImage(item) {
      return gradientImage(item.backgroundColor)
    },
    getStyleObjectForBlock(item) {
      return {
        ...border(item.style.border)
      };
    },
    isCardOnBlock(item) {
      const style = (item.inherit || false) ?  this.css : item;

      if ( typeof style.boxShadow === "undefined") {
        return false
      }

      return (style.inherit || false) ? this.css.boxShadow.visible : style.boxShadow.visible;
    },
    getBoxShadow(item) {
      const style = (item.inherit || false) ?  this.css : item;

      if ( typeof style.boxShadow === "undefined") {
        return 0
      }

      return (style.inherit || false) ? this.css.boxShadow.blurRadius : style.boxShadow.blurRadius
    },
    getBoxShape(item) {

      const style = (item.inherit || false) ? this.css : item;

      if ( typeof style.boxShadow === "undefined") {
        return 'none';
      }

      return (style.inherit || false) ? this.css.boxShadow.shape : style.boxShadow.shape
    }
  }
}
